import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  list: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
}));
